export default __webpack_public_path__ + "static/media/manag.1e9be629.svg";